import type { ApplicationSettings } from 'owa-application-settings';
import { type B2ServiceApiMode } from '../B2ServiceApiMode';

/**
 *  B2Service configuration type from ApplicationSettings
 */
type B2ServiceConfiguration = ApplicationSettings['B2Service'];

/**
 * Case-insensitive check if an action name exists in an array
 */
function containsAction(actions: string[] | undefined, actionName: string): boolean {
    if (!actions) {
        return false;
    }
    const normalizedActionName = actionName.toLowerCase();
    return actions.some(action => action.toLowerCase() === normalizedActionName);
}

/**
 * Gets the API mode for a specific action from a B2Service configuration object.
 * This abstracts the logic of checking which array contains the actionName.
 *
 * @param config - The B2Service configuration object (from ApplicationSettings or localStorage)
 * @param actionName - The action name to check
 * @returns The B2ServiceApiMode if found in one of the arrays, undefined if not configured (disabled)
 */
export function getAPIModeFromConfiguration(
    config: B2ServiceConfiguration | undefined,
    actionName: string
): B2ServiceApiMode {
    if (!config) {
        return 0;
    }

    // Check each array and return the corresponding mode
    if (containsAction(config.shadowModeEnabledAPIs, actionName)) {
        return 1;
    }

    if (containsAction(config.fallbackModeEnabledAPIs, actionName)) {
        return 2;
    }

    // API is not in any enabled array, considered disabled
    return 0;
}
